import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { NotificationManager } from "react-notifications";
import Select from "react-select";
import dollor from "../../../assets/icons/dollar.svg";
import SearchDropdown from "../../../components/Dropdowns/SearchDropdown";
import FilterFieldHeader from "../../../components/FilterComponents/FilterFieldHeader";
import FilterTabData from "../../../components/FilterComponents/FilterTabData";
import OptionalOption from "../../../components/FilterComponents/OptionalOption";
import InputWithIcon from "../../../components/InputWithIcon";
import useAuth from "../../../hooks/useAuth";
import { BASE_URL } from "../../../utils/Element";
import { filterThreeTabData } from "../../../utils/options";

const PipelineFilterData = ({ filterData, handleFilterChange, onSetFilterData, isSidebarOpen , onSetAcquisitionsData }) => {
  const [config] = useAuth();
  const [bdsOptions, setBdsOptions] = useState([]);
  const selectRef = useRef(null);
  const [contactData, setContactData] = useState([]);
  const [transactionOptions, setTransactionOptions] = useState([]);
  const [stageOptions, setStageOptions] = useState([]);


  const fetchSuggestions = (inputValue) => {
    axios
      .get(`${BASE_URL}/get-datalisting?list=contacts&search=${inputValue}`, config)
      .then((res) => {
        const data = res.data.data.contact_list;
        const options = data.map((contact) => ({ value: contact.id, label: `${contact.first_name} ${contact.last_name}` }));
        setContactData(options);
      })
      .catch((err) => {
        if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
          NotificationManager.error(err.response?.data?.message);
        }
      });
  };


  const fetchUsers = (listType) => {
    axios
      .get(`${BASE_URL}/get-datalisting?list=${listType}`, config)
      .then((res) => {
        const data = res?.data?.data;
        const userOptions = data?.users.map((el) => ({
          value: el?.id,
          label: `${el?.first_name} ${el?.last_name}`,
          role: el?.role_id,
        }));
        const transactionOptions = data?.transaction_type?.map((el) => ({
          value: el?.id,
          label: `${el?.name}`,
        }));
        const stageOptions = data?.stage?.map((el) => ({
          value: el?.id,
          label: `${el?.name}`,
        }));


        switch (listType) {
          case "usersList&role_id=3":
            setBdsOptions(userOptions);
            break;
          case "transaction_type":
            setTransactionOptions(transactionOptions);
            break;
          case "stage":
            setStageOptions(stageOptions);
            break;
          default:
            break;
        }
      })
      .catch((err) => {
        if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
          NotificationManager.error(err.response?.data?.message);
        }
      });
  };

  useEffect(() => {
    if (isSidebarOpen) {
      fetchUsers("usersList&role_id=3");
      fetchUsers("transaction_type");
      fetchUsers("stage");
    }
  }, [isSidebarOpen]);

  const lastupdatehandler = () => {
    onSetFilterData({ ...filterData, last_contact: "date", lastContactSentDate: "" });
  };
  const handlePriceClear = () => {
    onSetFilterData({ ...filterData, min_potential_gcl: "", max_potential_gcl: "" });
  };

  


  return (
    <div className="">
            <div>
             <p className="head-4 dark-H">Contact</p>
     
             <div className="mt-2">
               <SearchDropdown
                 isTop={false}
                 placeholder={`Search contact`}
                 text={filterData?.contact?.name}
                 options={contactData}
                 fetchSuggestions={fetchSuggestions}
                 onSetOptions={(value) => setContactData(value)}
                 handleSelect={(option) => {
                   onSetFilterData({
                     ...filterData,
                     contact: { id: option?.value, name: option?.label },
                   });
                   setContactData([]);
                 }}
               />
             </div>
           </div>

      <hr className="my-6" style={{ borderColor: "#6F6F6F" }} />
         
       <div className="mt-4">
         <p className="head-4 dark-H mb-2">Transaction Type</p>
  
         <Select
           options={transactionOptions}
           className="body-N mt-2"
           placeholder="Select transaction type"
           value={transactionOptions.find((option) => option.value === filterData?.transaction_type) || null}
           onChange={(option) => handleFilterChange(option?.value, "transaction_type")}
          />
       </div>
        

      <hr className="my-6" style={{ borderColor: "#6F6F6F" }} />

      <div className="mt-4">
        <p className="head-4 dark-H">Stage</p>

        <Select
           options={stageOptions}
           className="body-N mt-2"
           placeholder="Select stage"
           value={stageOptions.find((option) => option.value === filterData?.stage) || null}
          onChange={(option) => handleFilterChange(option?.value, "stage")}
         />
      </div>

      <hr className="my-6" style={{ borderColor: "#6F6F6F" }} />

        <div>
        <FilterTabData
          title={"Last Contacted"}
          tabData={filterThreeTabData}
          activeTab={filterData?.last_contact}
          lastDate={filterData?.lastContactSentDate}
          handleLastUpdate={lastupdatehandler}
          onSetActiveTab={(value) => {
            onSetFilterData({ ...filterData, last_contact: value, lastContactSentDate: "", lastContactSentSdate: "", lastContactSentEdate: "", date_category: "days", within_last_day: "", longer_than_day: "" });
          }}
        />
        <OptionalOption
          activeTab={filterData?.last_contact}
          onSetLastDate={(value) => {
            handleFilterChange(value, "lastContactSentDate");
          }}
          date={filterData?.lastContactSentDate}
          onSetDateRange1={(value) => handleFilterChange(value, "lastContactSentSdate")}
          date2={filterData?.lastContactSentSdate}
          onSetDateRange2={(value) => handleFilterChange(value, "lastContactSentEdate")}
          date3={filterData?.lastContactSentEdate}
          category={filterData?.date_category}
          onSetCategory={(value) => handleFilterChange(value, "date_category")}
          lastUp_days={filterData?.last_contact === "within_last" ? filterData?.within_last_day : filterData?.last_contact === "longer_than" ? filterData?.longer_than_day : ""}
          onSetDays={(value) => {
            if (filterData?.last_contact === "within_last") {
              onSetFilterData({ ...filterData, within_last_day: value, longer_than_day: "" });
            } else if (filterData?.last_contact === "longer_than") {
              onSetFilterData({ ...filterData, within_last_day: "", longer_than_day: value });
            } else {
              onSetFilterData({ ...filterData, within_last_day: "", longer_than_day: "" });
            }
          }}
          onClear={() => {
            onSetFilterData({ ...filterData, lastContactSentDate: "", lastContactSentSdate: "", lastContactSentEdate: "" });
          }}
        />
        <hr className="my-6" style={{ borderColor: "#6F6F6F" }} />
       </div>

      <div className="mt-4">
        <label className="dark-H head-4 mb-4">Associate</label>
        <div className="mt-2">
          <Select
            ref={selectRef}
            className="body-N"
            options={bdsOptions}
            placeholder="Select"
            value={bdsOptions.find((option) => option?.value === filterData?.associate_id) || null}
            onChange={(option) => handleFilterChange(option?.value, "associate_id")}
          />
        </div>

        <hr className="my-6" style={{ borderColor: "#6F6F6F" }} />
      </div>

        <div className="mt-4">
              <FilterFieldHeader 
              type={"to"} 
              title={"Potentail Gci"}
              data={filterData?.min_potential_gcl} 
              data2={filterData?.max_potential_gcl}
              handleCross={handlePriceClear} />
      
              <div className="flex flex-row mt-4">
                <div className="w-[48%]">
                  <InputWithIcon
                    icon={dollor}
                    className="body-N"
                    type="number"
                    min={0}
                    placeholder=" min Potentail Gci "
                    value={filterData?.min_potential_gcl}
                    onChange={(e) => {
                      handleFilterChange(e.target.value, "min_potential_gcl");
                    }}
                    onWheel={(e) => e.target.blur()}
                  />
                </div>
                <div className="w-[48%]">
                  <InputWithIcon
                    icon={dollor}
                    className="body-N"
                    type="number"
                    min={0}
                    placeholder="max Potentail Gci"
                    value={filterData?.max_potential_gcl}
                    onChange={(e) => {
                      handleFilterChange(e.target.value, "max_potential_gcl");
                    }}
                    onWheel={(e) => e.target.blur()}
                  />
                </div>
              </div>
        </div>

        <hr className="my-6" style={{ borderColor: "#6F6F6F" }} />

         <div className="mt-4">
              <FilterFieldHeader 
              type={"to"} 
              title={"Potentail Advisor Commission"}
              data={filterData?.min_potential_advisor_commission} 
              data2={filterData?.max_potential_advisor_commission}
              handleCross={handlePriceClear} />
      
              <div className="flex flex-row mt-4">
                <div className="w-[48%]">
                  <InputWithIcon
                    icon={dollor}
                    className="body-N"
                    type="number"
                    min={0}
                    placeholder=" min Potentail Advisor Commission "
                    value={filterData?.min_potential_advisor_commission}
                    onChange={(e) => {
                      handleFilterChange(e.target.value, "min_potential_advisor_commission");
                    }}
                    onWheel={(e) => e.target.blur()}
                  />
                </div>
                <div className="w-[48%]">
                  <InputWithIcon
                    icon={dollor}
                    className="body-N"
                    type="number"
                    min={0}
                    placeholder="max Potentail Advisor Commission"
                    value={filterData?.max_potential_advisor_commission}
                    onChange={(e) => {
                      handleFilterChange(e.target.value, "max_potential_advisor_commission");
                    }}
                    onWheel={(e) => e.target.blur()}
                  />
                </div>
              </div>
        </div>

     </div>
  );
};

export default PipelineFilterData;
